const _getValidPriceValue = (value: any) => {
  if (value === "-" || value !== null || isNaN(value)) {
    return value;
  }
  return value.toFixed(2);
};

export { _getValidPriceValue };
